<form #form="ngForm" class="atividade-retorno-form" novalidate>
    <div class="row">
        <div class="form-group col-12">
            <!-- <label class="col-form-label">Retornar?</label>
            <br/> -->
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" name="retornar" id="retornarSim_{{entity?.id}}" [value]="true" [ngModel]="entity.retornar" (ngModelChange)="onChangeRetornar($event)"
                    #retornar="ngModel" required="required"  [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                <label class="custom-control-label" for="retornarSim_{{entity?.id}}">Sim</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" name="retornar" id="retornarNao_{{entity?.id}}" [value]="false" [ngModel]="entity.retornar" (ngModelChange)="onChangeRetornar($event)"
                    required="required"  [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                <label class="custom-control-label" for="retornarNao_{{entity?.id}}">Não</label>
            </div>
            <p class="form-text text-muted">Se é necessário retornar esta atividade</p>
        </div>
    </div>

    <ng-template [ngIf]="entity.retornar">
        <ng-template [ngIf]="entity.atividadeRetornoInsert">
            <div class="row">
                <div class="form-group col-12">
                    <label class="col-form-label">Tipo do Retorno</label>
                    <br/>
                    <sgt-atividade-tipo-select
                        #ativiadeTipoSelect
                        [(ngModel)]="entity.atividadeRetornoInsert.tipo"
                        name="tipoRetorno"
                        id="tipoRetorno_{{entity?.id}}"
                        [required]="true">
                    </sgt-atividade-tipo-select>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="usuarioDestinoRetorno_{{entity?.id}}" class="col-form-label">Responsável pelo Retorno</label>
                    <sgt-usuario-select
                        [idUsuario]="entity.atividadeRetornoInsert.idUsuarioDestino"
                        (usuarioChange)="onChangeResponsavelRetorno($event)"
                        empityName="Nenhum responsável">
                    </sgt-usuario-select>
                    <p class="form-text text-muted">Responsável por executar este retorno. Deixei em branco para atributir a atividade a si mesmo</p>
                </div>
            </div>
            <div class="row" *ngIf="ativiadeTipoSelect?.config?.isTarefa">
                <div class="form-group col-12">
                    <label for="titulo" class="col-form-label">Título</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.atividadeRetornoInsert.titulo" name="tituloRetorno" id="tituloRetorno_{{entity?.id}}"
                        #titulo="ngModel" required="required">
                    <p class="form-text text-muted">Informe um título para identificar este retorno</p>
                    <sgt-form-control-error
                        *ngIf="titulo.errors && titulo.errors.required && titulo.dirty"
                        msgError="O título do retorno é obrigatório">
                    </sgt-form-control-error>
                </div>
            </div>
        </ng-template>

        <div class="row">
            <div class="form-group col-12 col-md-5 col-lg-4">
                <label for="diaRetorno_{{entity?.id}}" class="col-form-label">Retornar Em</label>
                <sgt-datepicker [(ngModel)]="entity.diaRetorno" name="diaRetorno" id="diaRetorno_{{entity?.id}}"
                    #diaRetornoModel="ngModel"  #diaRetornoDatepicker [ngControl]="diaRetornoModel" required="required">
                </sgt-datepicker>
                <p class="form-text text-muted">Dia e hora pra retornar esta atividade</p>
                <sgt-form-control-error
                    *ngIf="diaRetornoModel.errors && diaRetornoModel.errors.required && diaRetornoModel.dirty"
                    msgError="O dia do retorno é obrigatório">
                </sgt-form-control-error>
            </div>
            <div class="form-group col-12 col-md hora-retorno">
                <timepicker class="timepicker" [(ngModel)]="entity.horaRetorno" [mousewheel]="false" [showMeridian]="false" [minuteStep]="1" name="horaRetorno" id="horaRetorno_{{entity?.id}}">
                </timepicker>
            </div>
        </div>

        <ng-template [ngIf]="entity.atividadeRetornoInsert">
            <div class="row">
                <div class="form-group col-12">
                    <label for="comentario_{{entity?.id}}" class="col-form-label">Comentário do Retorno</label>
                    <textarea class="form-control" [(ngModel)]="entity.atividadeRetornoInsert.comentario" name="comentario" id="comentario_{{entity?.id}}"
                        #comentario="ngModel" rows="3" sgtAutosize>
                    </textarea>
                    <p class="form-text text-muted">Comentário sobre este retorno</p>
                </div>
            </div>
        </ng-template>
    </ng-template>

    <div class="mb-2">
        <sgt-atividade-ref-card-info
            [atividade]="entity.atividadeRetorno"
            (openAtividade)="openAtividade.emit($event)">
        </sgt-atividade-ref-card-info>
    </div>
</form>
